var map = {
	"./01.png": "a4f1",
	"./01_large.png": "cb78",
	"./02.png": "8d2d",
	"./02_large.png": "1ef2",
	"./03.png": "57c0",
	"./03_large.png": "12ae",
	"./05.png": "8cf1",
	"./05_large.png": "2a34",
	"./06.png": "86fe",
	"./06_large.png": "ba43"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f264";